/**
 * @author xzc
 * 功能：凭证
 */

import { Service } from '@/tools'

export class ProofSourceItemService<T extends TSettle.ProofPreposition> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TSettle.ProofPreposition}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  // 凭证来源单据明细列表
  // /api/settle/proofSourceItem/v1/findListByCondition
  findListByCondition = <K extends T['ApiFindListByCondition']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiFindListByCondition', data)
}
